import z from 'zod'
import {
  ctaUrlValidationMessage,
  validateCtaUrlTemplate
} from '../helpers/substituteCtaUrlTemplate'

export const ctaPlacementSchema = z.object({
  id: z.string().min(1),
  ctaId: z.string().min(1),
  x0: z.number().min(0),
  y0: z.number().min(0),
  width: z.number().positive(),
  height: z.number().positive()
})

export type TCtaPlacement = z.infer<typeof ctaPlacementSchema>

export const ctaUrlTemplateSchema = z.string().min(1).max(2048).superRefine((url, ctx) => {
  const result = validateCtaUrlTemplate(url)
  if (!result.ok) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: ctaUrlValidationMessage(result.code, { unknownPlaceholders: result.unknownPlaceholders })
    })
  }
})

export const ctaUpsertBodySchema = z.object({
  name: z.string().trim().min(1).max(120),
  description: z
    .union([z.string().max(500), z.null()])
    .optional()
    .transform((value) => {
      if (value == null || value === '') { return null }
      const trimmed = value.trim()
      return trimmed === '' ? null : trimmed
    }),
  url: ctaUrlTemplateSchema
})

export type TCtaUpsertBody = z.infer<typeof ctaUpsertBodySchema>

export const ctaRecordSchema = ctaUpsertBodySchema.extend({
  id: z.string().min(1),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date()
})

export type TCtaRecord = z.infer<typeof ctaRecordSchema>

export const ctaListItemSchema = ctaRecordSchema.extend({
  frameUsageCount: z.number().int().nonnegative()
})

export type TCtaListItem = z.infer<typeof ctaListItemSchema>

export const ctaRegistryEntrySchema = z.object({
  id: z.string(),
  name: z.string(),
  url: z.string()
})

export type TCtaRegistryEntry = z.infer<typeof ctaRegistryEntrySchema>
